import {Injectable} from '@angular/core';
import {CookieService} from "ngx-cookie-service";

@Injectable({
  providedIn: 'root'
})
export class CcStorageService {

  constructor(private cookieService: CookieService) {
  }

  set(name: string, value: string): void {
    localStorage.setItem(name, value);
  }

  get(name: string): string {
    const value = localStorage.getItem(name);
    if (!value) return '';
    return value;
  }

  getAll(): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) result[key] = this.get(key);
    }
    return result;
  }

  check(name: string): boolean {
    return localStorage.getItem(name) !== null;
  }

  delete(name: string): void {
    localStorage.removeItem(name);
  }

  deleteAll(): void {
    localStorage.clear();
    this.cookieService.deleteAll('/');
  }
}
